import { onUnmounted, ref, watch } from "@vue/composition-api";

export default function useDynamicSizing(svgRef, marginRef) {
  const width = ref(0);
  const height = ref(0);
  const availableWidth = ref(0);
  const availableHeight = ref(0);

  const updateDimensions = () => {
    const container = svgRef.value?.parentElement;

    if (container) {
      const w = container.offsetWidth;
      const h = container.offsetHeight;

      width.value = w;
      height.value = h;

      const aw = w - marginRef.value.left - marginRef.value.right;
      availableWidth.value = (aw > 0) ? aw : 0;

      const ah = h - marginRef.value.top - marginRef.value.bottom;
      availableHeight.value = (ah > 0) ? ah : 0;
    } else {
      width.value = 0;
      height.value = 0;
      availableWidth.value = 0;
      availableHeight.value = 0;
    }
  };

  const updateDimensionsInRAF = () => requestAnimationFrame(updateDimensions);

  const observer = new ResizeObserver(updateDimensionsInRAF);

  watch(svgRef, (newSvg, oldSvg) => {
    if (oldSvg) {
      observer.unobserve(oldSvg.parentElement);
    }

    if (newSvg) {
      observer.observe(newSvg.parentElement);
    }
  });

  watch(marginRef, updateDimensionsInRAF);

  onUnmounted(() => {
    if (svgRef.value?.parentElement) {
      observer.unobserve(svgRef.value.parentElement);
    }
  });

  return { width, height, availableWidth, availableHeight };
}
